import { observable, makeObservable } from "mobx";
import { getLabs } from "../../serviceCalls";

export default class LabsStore {
  labs;
  loading;

  constructor() {
    makeObservable(this, {
      labs: observable,
      loading: observable,
    });
  }

  fetchLabs({ asmpid }) {
    this.loading = true;
    getLabs({ asmpid })
      .then((res) => {
        this.labs = {
          groups: res.groups.map((group) => ({
            ...group,
            items: group.items.map((item, i) => ({
              ...item,
              id: i,
            })),
          })),
        };
      })
      .catch(console.error)
      .finally(() => (this.loading = false));
  }
}
